// extracted by mini-css-extract-plugin
module.exports = {"dialogTitle":"OnLeaveDialog_dialogTitle__3uM_D","button":"OnLeaveDialog_button__fXt6h"};